import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenDistributionPage } from '@/features/product/pages/SpecimenDistributionPage';
import { specimenDistributionSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/specimen-distribution/')({
  validateSearch: specimenDistributionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen Distribution">
      <Suspense fallback={<PageLoader />}>
        <SpecimenDistributionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
